import { useEffect, useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { PackageCheck } from "lucide-react";
import { Switch } from "@/components/ui/switch";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Consentement : un client qui saisit mon numéro comme destinataire peut utiliser ma position GPS
export const DeliverySharingToggle = ({ user }) => {
  const [on, setOn] = useState(!!user?.share_location_for_delivery);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    if (!user?.id) return;
    axios.get(`${API}/users/${user.id}`).then(({ data }) => setOn(!!data.share_location_for_delivery)).catch(() => {});
  }, [user?.id]);

  const change = async (v) => {
    setSaving(true);
    try {
      await axios.put(`${API}/users/me/delivery-sharing`, { enabled: v });
      setOn(v);
      toast.success(v ? "Vos proches peuvent vous envoyer un colis à votre position" : "Partage de position désactivé");
    } catch (e) {
      toast.error(e.response?.data?.detail || "Impossible d'enregistrer");
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="bg-[#1E293B] border border-white/5 rounded-[2rem] p-5 flex items-center gap-4" data-testid="delivery-sharing-card">
      <div className="w-11 h-11 rounded-xl bg-[#D4AF37]/10 border border-[#D4AF37]/30 flex items-center justify-center text-[#D4AF37] shrink-0">
        <PackageCheck className="w-5 h-5" />
      </div>
      <div className="flex-1 min-w-0">
        <p className="font-black text-sm text-white">Je peux recevoir des colis à ma position</p>
        <p className="text-[11px] text-gray-400 mt-1">
          Quand un client saisit votre numéro comme destinataire, votre position GPS remplit l'adresse de livraison. Désactivé, il saisit l'adresse à la main.
        </p>
      </div>
      <Switch checked={on} disabled={saving} onCheckedChange={change} data-testid="delivery-sharing-switch" />
    </div>
  );
};
